"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GROUP = void 0;
const GROUP = exports.GROUP = 'group';
